<template>
  <div class="relative">
    <div class="multi-select">
      <div
          class="multi-select__field flex flex-wrap w-full max-w-full pt-1 border border-gray-700 rounded"
          @click="clickOnEmptyField">
        <div
            class="multi-select__item flex items-center text-xs ml-1 mb-1 p-0.5 px-1.5 bg-gray-200 rounded"
            v-if="computedValue.length" v-for="item in computedValue" :key="item.id">
            {{ item.type === 'brand' ? __('Manufacturer') : '' }} {{ item.name }}
          <jb-button
              :small="true"
              class="bg-white rounded-md p-0.5 ml-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
              @click.prevent="removeItem(item)" :icon="mdiCloseBox"/>
        </div>
        <div class="mb-1 pl-2 multi-select__empty" v-else @click="clickOnEmptyText">
          {{ __('Nothing selected') }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.multi-select__empty {
  cursor: pointer;
  width: 100%;
  min-height: 2.375rem;
  height: 2.375rem;
  line-height: 2.375rem;
}

.multi-select__item {
  min-height: 2.375rem;
  animation: new-item 1.5s ease;
}

.multi-select__field {
  min-height: 3rem;
}

@keyframes new-item {
  0% {
    background-color: rgba(167, 243, 208, 1);
  }
  100% {
    background-color: rgba(229, 231, 235, 1);
  }
}
</style>

<script>
import {computed} from 'vue'
import JbButton from '@/Components/Dashboard/JbButton'

import {
  mdiCloseBox
} from '@mdi/js'

export default {
  name: "MultiSelect",
  components: {
    JbButton
  },
  props: {
    modelValue: {
      type: Array,
      default: []
    }
  },
  emits: ['update:modelValue', 'clickOnEmptyText', 'clickOnEmptyField'],
  methods: {
    removeItem(itemToRemove) {
      this.computedValue = this.computedValue.filter(item => item != itemToRemove)
    }
  },
  setup(props, {emit}) {
    const computedValue = computed({
      get: () => props.modelValue,
      set: value => {
        emit('update:modelValue', value)
      }
    })

    const clickOnEmptyText = () => emit('clickOnEmptyText')

    const clickOnEmptyField = (e) => {
      if (e.target.classList.contains('multi-select__field')) {
        emit('clickOnEmptyField')
      }
    }

    return {
      mdiCloseBox,
      computedValue,
      clickOnEmptyText,
      clickOnEmptyField
    }
  }
}
</script>
